(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christmas-calendar-gifts"] && !Shopify.designMode) return;
  try {
    
  const getLondonCalendarDay = () => {
    const dateParts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      month: 'numeric',
      day: 'numeric'
    }).formatToParts(new Date());
    const month = Number(dateParts.find((part) => part.type === 'month')?.value);
    const day = Number(dateParts.find((part) => part.type === 'day')?.value);

    if (month !== 12 || day < 1 || day > 25) return null;
    return day;
  };

  const jumpToCurrentCalendarDay = (calendar) => {
    if (window.Shopify?.designMode || window.location.hash) return;

    const day = getLondonCalendarDay();
    const currentDoor = day ? calendar.querySelector(`#day-${day}`) : null;
    if (!currentDoor) return;

    const jump = () => {
      const stickyHeader = document.querySelector('sticky-header, .header-wrapper, .section-header');
      const headerHeight = stickyHeader?.getBoundingClientRect().height || 0;
      const targetTop = currentDoor.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: 'auto' });
    };

    if (document.readyState === 'complete') {
      requestAnimationFrame(jump);
    } else {
      window.addEventListener('load', () => requestAnimationFrame(jump), { once: true });
    }
  };

  const fitOpenCalendarDoor = (door) => {
    const scene = door.querySelector('.kmc-calendar__scene');
    const reveal = door.querySelector('.kmc-calendar__reveal');
    if (!scene || !reveal) return;

    if (!door.classList.contains('is-open') || !window.matchMedia('(max-width: 749px)').matches) {
      scene.style.removeProperty('min-height');
      return;
    }

    requestAnimationFrame(() => {
      scene.style.removeProperty('min-height');
      const revealHeight = Math.ceil(reveal.scrollHeight);
      scene.style.minHeight = `${Math.max(440, revealHeight)}px`;
    });
  };

  const prepareIceSurprises = (calendar) => {
    if (calendar.dataset.icePrepared === 'true') return;
    calendar.dataset.icePrepared = 'true';
    if (calendar.dataset.iceEnabled !== 'true') return;

    const candidates = Array.from(calendar.querySelectorAll('.kmc-calendar__door.has-gift:not(.is-locked)'));
    if (!candidates.length) return;

    const designMode = calendar.dataset.designMode === 'true';
    const chance = Math.min(60, Math.max(10, Number(calendar.dataset.iceChance) || 30));
    const maximum = candidates.length > 1 ? candidates.length - 1 : 1;
    const count = designMode ? 1 : Math.min(maximum, Math.max(1, Math.round(candidates.length * chance / 100)));

    for (let index = candidates.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [candidates[index], candidates[randomIndex]] = [candidates[randomIndex], candidates[index]];
    }

    candidates.slice(0, count).forEach((door) => {
      const iceButton = door.querySelector('[data-calendar-ice]');
      if (!iceButton) return;
      door.classList.add('has-ice');
      iceButton.hidden = false;
    });
  };

  const breakCalendarIce = (door, iceButton) => {
    if (door.classList.contains('ice-broken')) return;
    door.classList.add('ice-broken');

    const reveal = door.querySelector('.kmc-calendar__reveal');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let completed = false;
    const complete = () => {
      if (completed) return;
      completed = true;
      iceButton.hidden = true;
      iceButton.classList.remove('is-breaking');
      reveal?.focus({ preventScroll: true });
      fitOpenCalendarDoor(door);
    };

    if (reducedMotion) {
      complete();
      return;
    }

    iceButton.classList.add('is-breaking');
    for (let index = 0; index < 18; index += 1) {
      const shard = document.createElement('span');
      shard.className = 'kmc-calendar__ice-shard';
      shard.style.setProperty('--ice-top', `${15 + Math.random() * 70}%`);
      shard.style.setProperty('--ice-left', `${12 + Math.random() * 76}%`);
      shard.style.setProperty('--ice-size', `${10 + Math.random() * 18}px`);
      shard.style.setProperty('--ice-x', `${Math.round((Math.random() - 0.5) * 320)}px`);
      shard.style.setProperty('--ice-y', `${Math.round((Math.random() - 0.35) * 300)}px`);
      shard.style.setProperty('--ice-r', `${Math.round((Math.random() - 0.5) * 720)}deg`);
      door.appendChild(shard);
      shard.addEventListener('animationend', () => shard.remove(), { once: true });
    }

    iceButton.addEventListener('animationend', complete, { once: true });
    window.setTimeout(complete, 900);
  };

  const initChristmasCalendars = (root = document) => {
    root.querySelectorAll('[data-christmas-calendar]:not([data-calendar-ready])').forEach((calendar) => {
      calendar.dataset.calendarReady = 'true';
      prepareIceSurprises(calendar);
      jumpToCurrentCalendarDay(calendar);

      calendar.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openDoor = event.target.closest('.kmc-calendar__door.is-open');
        if (!openDoor) return;
        event.preventDefault();
        openDoor.querySelector('[data-calendar-close]')?.click();
      });

      calendar.addEventListener('click', (event) => {
        const openButton = event.target.closest('[data-calendar-open]');
        const closeButton = event.target.closest('[data-calendar-close]');
        const iceButton = event.target.closest('[data-calendar-ice]');
        const door = event.target.closest('.kmc-calendar__door');
        if (!door || !calendar.contains(door) || door.classList.contains('is-locked') || (!openButton && !closeButton && !iceButton)) return;

        const reveal = door.querySelector('.kmc-calendar__reveal');
        const trigger = door.querySelector('[data-calendar-open]');

        if (iceButton) {
          if (!door.classList.contains('is-open')) return;
          breakCalendarIce(door, iceButton);
          return;
        }

        if (openButton) {
          if (openButton.disabled || door.classList.contains('is-open')) return;
          door.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          reveal.setAttribute('aria-hidden', 'false');
          reveal.inert = false;
          trigger.tabIndex = -1;
          const focusOpenedDoor = () => {
            if (!door.classList.contains('is-open')) return;
            const frozen = door.classList.contains('has-ice') && !door.classList.contains('ice-broken');
            const focusTarget = frozen ? door.querySelector('[data-calendar-ice]') : reveal;
            focusTarget?.focus({ preventScroll: true });
          };
          window.setTimeout(focusOpenedDoor, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 850);
          fitOpenCalendarDoor(door);

          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            for (let index = 0; index < 12; index += 1) {
              const piece = document.createElement('span');
              piece.className = 'kmc-calendar__confetti';
              piece.style.setProperty('--confetti-x', `${Math.round((Math.random() - 0.5) * 220)}px`);
              piece.style.setProperty('--confetti-y', `${Math.round((Math.random() - 0.7) * 220)}px`);
              piece.style.setProperty('--confetti-r', `${Math.round(Math.random() * 540)}deg`);
              piece.style.background = index % 2 ? 'var(--calendar-ribbon)' : 'var(--calendar-accent)';
              door.appendChild(piece);
              piece.addEventListener('animationend', () => piece.remove(), { once: true });
            }
          }
        }

        if (closeButton) {
          door.classList.remove('is-open');
          fitOpenCalendarDoor(door);
          trigger.setAttribute('aria-expanded', 'false');
          reveal.setAttribute('aria-hidden', 'true');
          reveal.inert = true;
          trigger.tabIndex = 0;
          trigger.focus();
        }
      });
    });
  };

  initChristmasCalendars();
  let calendarResizeFrame;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(calendarResizeFrame);
    calendarResizeFrame = requestAnimationFrame(() => {
      document.querySelectorAll('[data-christmas-calendar] .kmc-calendar__door.is-open').forEach(fitOpenCalendarDoor);
    });
  }, { passive: true });
  document.addEventListener('shopify:section:load', (event) => {
    initChristmasCalendars(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gel-x-creator-brief"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root = document) => {
      root.querySelectorAll('[data-gxc-countdown]').forEach((countdown) => {
        if (countdown.dataset.ready === 'true') return;

        const target = Date.parse(countdown.dataset.gxcCountdown || '');
        if (Number.isNaN(target)) {
          countdown.hidden = true;
          return;
        }

        countdown.dataset.ready = 'true';
        const fields = {
          days: countdown.querySelector('[data-days]'),
          hours: countdown.querySelector('[data-hours]'),
          minutes: countdown.querySelector('[data-minutes]'),
          seconds: countdown.querySelector('[data-seconds]')
        };

        const update = () => {
          const remaining = Math.max(0, target - Date.now());
          const totalSeconds = Math.floor(remaining / 1000);
          const values = {
            days: Math.floor(totalSeconds / 86400),
            hours: Math.floor((totalSeconds % 86400) / 3600),
            minutes: Math.floor((totalSeconds % 3600) / 60),
            seconds: totalSeconds % 60
          };

          Object.entries(values).forEach(([key, value]) => {
            if (fields[key]) fields[key].textContent = String(value).padStart(2, '0');
          });

          if (remaining === 0) countdown.hidden = true;
        };

        update();
        window.setInterval(update, 1000);
      });
    };

    initialise();
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gel-x-press-room"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sleep = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

    const initialiseCountdown = (countdown) => {
      if (countdown.dataset.gxpCountdownReady === 'true') {
        return;
      }

      const targetTime = Date.parse(countdown.dataset.target || '');
      if (Number.isNaN(targetTime)) {
        countdown.hidden = true;
        return;
      }

      countdown.dataset.gxpCountdownReady = 'true';
      const completeMessage = countdown.parentElement.querySelector('[data-gxp-countdown-complete]');
      const fields = {
        days: countdown.querySelector('[data-days]'),
        hours: countdown.querySelector('[data-hours]'),
        minutes: countdown.querySelector('[data-minutes]'),
        seconds: countdown.querySelector('[data-seconds]')
      };

      const update = () => {
        const remaining = Math.max(0, targetTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60
        };

        Object.entries(values).forEach(([key, value]) => {
          if (fields[key]) {
            fields[key].textContent = String(value).padStart(2, '0');
          }
        });

        if (remaining === 0) {
          countdown.hidden = true;
          if (completeMessage) {
            completeMessage.hidden = false;
          }
          return false;
        }

        return true;
      };

      if (update()) {
        const interval = window.setInterval(() => {
          if (!update()) {
            window.clearInterval(interval);
          }
        }, 1000);
      }
    };

    const getFilename = (url, index) => {
      try {
        const parsedUrl = new URL(url, window.location.href);
        const pathName = decodeURIComponent(parsedUrl.pathname);
        const fileName = pathName.split('/').filter(Boolean).pop();
        return fileName || `gel-x-media-${index + 1}`;
      } catch (error) {
        return `gel-x-media-${index + 1}`;
      }
    };

    const downloadFile = async (url, index) => {
      const absoluteUrl = new URL(url, window.location.href).href;

      try {
        const response = await window.fetch(absoluteUrl, {
          credentials: 'omit',
          mode: 'cors'
        });

        if (!response.ok) {
          throw new Error(`Download failed with status ${response.status}`);
        }

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = getFilename(absoluteUrl, index);
        link.hidden = true;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
      } catch (error) {
        const fallbackLink = document.createElement('a');
        fallbackLink.href = absoluteUrl;
        fallbackLink.target = '_blank';
        fallbackLink.rel = 'noopener';
        fallbackLink.hidden = true;
        document.body.appendChild(fallbackLink);
        fallbackLink.click();
        fallbackLink.remove();
      }
    };

    const initialiseMediaLibrary = (sectionRoot) => {
      const gallery = sectionRoot.querySelector('.gxp-gallery--editable');
      const assetsSection = sectionRoot.querySelector('.gxp-assets');

      if (!gallery || !assetsSection || gallery.dataset.gxpCompactReady === 'true') {
        return;
      }

      gallery.dataset.gxpCompactReady = 'true';

      const cards = Array.from(gallery.querySelectorAll('.gxp-media-card'));
      const downloadUrls = [];

      cards.forEach((card, index) => {
        const title = card.querySelector('h3')?.textContent?.trim() || `GEL X media file ${index + 1}`;
        const mediaLink = card.querySelector('.gxp-media-card__media[href]');
        const downloadLink = card.querySelector('.gxp-media-card__link[href]');
        const video = card.querySelector('video');
        const videoSource = video?.currentSrc || video?.querySelector('source')?.src || '';
        const downloadUrl = mediaLink?.href || downloadLink?.href || videoSource;

        card.title = title;

        if (video) {
          card.classList.add('gxp-media-card--video-icon');
        }

        if (downloadUrl && !downloadUrls.includes(downloadUrl)) {
          downloadUrls.push(downloadUrl);
        }
      });

      const archiveUrl = sectionRoot.dataset.gxpArchiveUrl?.trim();
      const allDownloadUrls = [...new Set([
        ...(archiveUrl ? [new URL(archiveUrl, window.location.href).href] : []),
        ...downloadUrls
      ])];

      const toolbar = document.createElement('div');
      toolbar.className = 'gxp-media-toolbar';
      gallery.parentNode.insertBefore(toolbar, gallery);
      toolbar.appendChild(gallery);

      const button = document.createElement('button');
      button.className = 'gxp-btn gxp-download-all';
      button.type = 'button';
      button.textContent = sectionRoot.dataset.gxpDownloadLabel || 'Download all';
      button.setAttribute('aria-label', `Download all ${allDownloadUrls.length} selected media files`);
      toolbar.appendChild(button);

      const status = document.createElement('p');
      status.className = 'gxp-download-status';
      status.setAttribute('aria-live', 'polite');
      status.textContent = `${allDownloadUrls.length} media file${allDownloadUrls.length === 1 ? '' : 's'} selected.`;
      toolbar.appendChild(status);

      if (allDownloadUrls.length === 0) {
        button.disabled = true;
        status.textContent = 'No media files have been added yet.';
        return;
      }

      button.addEventListener('click', async () => {
        if (button.disabled) {
          return;
        }

        const defaultLabel = button.textContent;

        button.disabled = true;
        button.textContent = 'Preparing…';

        for (let index = 0; index < allDownloadUrls.length; index += 1) {
          status.textContent = `Downloading ${index + 1} of ${allDownloadUrls.length}…`;
          await downloadFile(allDownloadUrls[index], index);
          await sleep(250);
        }

        status.textContent = allDownloadUrls.length === 1
          ? 'Download started.'
          : `${allDownloadUrls.length} downloads started.`;
        button.textContent = defaultLabel;
        button.disabled = false;
      });
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll('[data-gxp-countdown]').forEach(initialiseCountdown);
      scope.querySelectorAll('[data-gxp-press-section]').forEach(initialiseMediaLibrary);
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gel-x-trade-room"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sleep = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

    const getFilename = (url, index) => {
      try {
        const parsedUrl = new URL(url, window.location.href);
        const pathName = decodeURIComponent(parsedUrl.pathname);
        const fileName = pathName.split('/').filter(Boolean).pop();
        return fileName || `gel-x-trade-asset-${index + 1}`;
      } catch (error) {
        return `gel-x-trade-asset-${index + 1}`;
      }
    };

    const downloadFile = async (url, index) => {
      const absoluteUrl = new URL(url, window.location.href).href;

      try {
        const response = await window.fetch(absoluteUrl, {
          credentials: 'omit',
          mode: 'cors'
        });

        if (!response.ok) {
          throw new Error(`Download failed with status ${response.status}`);
        }

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = getFilename(absoluteUrl, index);
        link.hidden = true;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
      } catch (error) {
        const fallbackLink = document.createElement('a');
        fallbackLink.href = absoluteUrl;
        fallbackLink.target = '_blank';
        fallbackLink.rel = 'noopener';
        fallbackLink.hidden = true;
        document.body.appendChild(fallbackLink);
        fallbackLink.click();
        fallbackLink.remove();
      }
    };

    const initialiseCountdown = (countdown) => {
      if (countdown.dataset.gxtCountdownReady === 'true') {
        return;
      }

      const targetTime = Date.parse(countdown.dataset.target || '');
      if (Number.isNaN(targetTime)) {
        countdown.hidden = true;
        return;
      }

      countdown.dataset.gxtCountdownReady = 'true';
      const completeMessage = countdown.parentElement.querySelector('[data-gxt-countdown-complete]');
      const fields = {
        days: countdown.querySelector('[data-days]'),
        hours: countdown.querySelector('[data-hours]'),
        minutes: countdown.querySelector('[data-minutes]'),
        seconds: countdown.querySelector('[data-seconds]')
      };

      const update = () => {
        const remaining = Math.max(0, targetTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60
        };

        Object.entries(values).forEach(([key, value]) => {
          if (fields[key]) {
            fields[key].textContent = String(value).padStart(2, '0');
          }
        });

        if (remaining === 0) {
          countdown.hidden = true;
          if (completeMessage) {
            completeMessage.hidden = false;
          }
          return false;
        }

        return true;
      };

      if (update()) {
        const interval = window.setInterval(() => {
          if (!update()) {
            window.clearInterval(interval);
          }
        }, 1000);
      }
    };

    const initialiseDownloadAll = (assetsSection) => {
      if (assetsSection.dataset.gxtDownloadReady === 'true') {
        return;
      }

      const button = assetsSection.querySelector('[data-gxt-download-all]');
      const status = assetsSection.querySelector('[data-gxt-download-status]');
      const linkUrls = Array.from(assetsSection.querySelectorAll('[data-gxt-download-url][href]'))
        .map((link) => new URL(link.href, window.location.href).href);
      const videoUrls = Array.from(assetsSection.querySelectorAll('.gxt-media-card video'))
        .map((video) => video.currentSrc || video.querySelector('source')?.src || '')
        .filter(Boolean);
      const downloadUrls = [...new Set([...linkUrls, ...videoUrls])];

      if (!button || !status) {
        return;
      }

      assetsSection.dataset.gxtDownloadReady = 'true';
      status.textContent = `${downloadUrls.length} file${downloadUrls.length === 1 ? '' : 's'} included.`;

      if (downloadUrls.length === 0) {
        button.disabled = true;
        status.textContent = 'No trade assets have been added yet.';
        return;
      }

      button.addEventListener('click', async () => {
        if (button.disabled) {
          return;
        }

        const defaultLabel = button.textContent;
        button.disabled = true;
        button.textContent = 'Preparing…';

        for (let index = 0; index < downloadUrls.length; index += 1) {
          status.textContent = `Downloading ${index + 1} of ${downloadUrls.length}…`;
          await downloadFile(downloadUrls[index], index);
          await sleep(250);
        }

        status.textContent = downloadUrls.length === 1
          ? 'Download started.'
          : `${downloadUrls.length} downloads started.`;
        button.textContent = defaultLabel;
        button.disabled = false;
      });
    };

    const initialiseCsvDownload = (assetsSection) => {
      if (assetsSection.dataset.gxtCsvReady === 'true') {
        return;
      }

      const button = assetsSection.querySelector('[data-gxt-download-csv]');
      const csvSource = assetsSection.querySelector('[data-gxt-csv]');

      if (!button || !csvSource) {
        return;
      }

      assetsSection.dataset.gxtCsvReady = 'true';

      button.addEventListener('click', () => {
        const csvContent = csvSource.textContent.trim();
        const csvBlob = new Blob([`\uFEFF${csvContent}\r\n`], {
          type: 'text/csv;charset=utf-8'
        });
        const objectUrl = URL.createObjectURL(csvBlob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = 'gel-x-trade-product-data.csv';
        link.hidden = true;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
      });
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll('[data-gxt-countdown]').forEach(initialiseCountdown);
      scope.querySelectorAll('.gxt-assets').forEach((assetsSection) => {
        initialiseDownloadAll(assetsSection);
        initialiseCsvDownload(assetsSection);
      });
    };

    initialiseAll();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kmc-b2b-order-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kmc-b2b-order-list')) {
    class KmcB2BOrderList extends HTMLElement {
      connectedCallback() {
        if (this.applyDefaultSort()) return;

        this.rows = Array.from(this.querySelectorAll('[data-order-row]'));
        this.categorySelect = this.querySelector('[data-category-select]');
        this.sortSelect = this.querySelector('[data-sort-select]');
        this.emptyState = this.querySelector('[data-empty-state]');
        this.floatingCart = this.querySelector('[data-floating-cart]');
        this.viewportUpdateQueued = false;
        this.handleViewportChange = () => this.queueFloatingPositionUpdate();

        this.sortSelect?.addEventListener('change', () => {
          this.sortSelect.form?.requestSubmit();
        });

        this.categorySelect?.addEventListener('change', () => this.filterRows());

        this.rows.forEach((row) => this.setupRow(row));
        window.addEventListener('resize', this.handleViewportChange);
        window.addEventListener('scroll', this.handleViewportChange, { passive: true });
        this.queueFloatingPositionUpdate();
        this.refreshCart();
      }

      applyDefaultSort() {
        if (this.dataset.designMode === 'true') return false;

        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.get('sort_by')) return false;

        const targetUrl = new URL(this.dataset.defaultSortUrl, window.location.origin);
        currentUrl.searchParams.forEach((value, key) => {
          if (key !== 'sort_by' && key !== 'page') targetUrl.searchParams.append(key, value);
        });

        window.location.replace(targetUrl.toString());
        return true;
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleViewportChange);
        window.removeEventListener('scroll', this.handleViewportChange);
      }

      queueFloatingPositionUpdate() {
        if (this.viewportUpdateQueued) return;
        this.viewportUpdateQueued = true;

        window.requestAnimationFrame(() => {
          this.viewportUpdateQueued = false;
          this.updateFloatingPosition();
        });
      }

      updateFloatingPosition() {
        if (!this.floatingCart?.classList.contains('kmc-b2b-order__floating--mobile-below_header')) return;
        if (!window.matchMedia('(max-width: 749px)').matches) {
          this.style.removeProperty('--kmc-b2b-mobile-checkout-top');
          return;
        }

        const stickyHeader = document.querySelector('.shopify-section-header-sticky, sticky-header');
        const headerBottom = stickyHeader ? Math.max(0, stickyHeader.getBoundingClientRect().bottom) : 0;
        this.style.setProperty('--kmc-b2b-mobile-checkout-top', `${headerBottom + 8}px`);
      }

      setupRow(row) {
        const minus = row.querySelector('[data-quantity-minus]');
        const plus = row.querySelector('[data-quantity-plus]');
        const input = row.querySelector('[data-quantity-input]');
        const addButton = row.querySelector('[data-add-button]');

        if (!minus || !plus || !input || !addButton) return;

        minus.addEventListener('click', () => {
          const current = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);
          const minimum = this.number(input.dataset.minimum, 1);
          const increment = this.number(input.dataset.increment, 1);
          input.value = current <= minimum ? 0 : Math.max(minimum, current - increment);
          this.updateRowControls(row);
        });

        plus.addEventListener('click', () => {
          const current = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);
          const minimum = this.number(input.dataset.minimum, 1);
          const increment = this.number(input.dataset.increment, 1);
          const maximum = this.maximum(input.dataset.maximum);
          const next = current === 0 ? minimum : current + increment;
          input.value = Math.min(maximum, next);
          this.updateRowControls(row);
        });

        input.addEventListener('change', () => {
          input.value = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);
          this.updateRowControls(row);
        });

        input.addEventListener('blur', () => {
          input.value = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);
          this.updateRowControls(row);
        });

        addButton.addEventListener('click', () => this.addRow(row));
        this.updateRowControls(row);
      }

      number(value, fallback) {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
      }

      maximum(value) {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : Number.POSITIVE_INFINITY;
      }

      normaliseQuantity(input, requested) {
        if (!requested || requested <= 0) return 0;

        const minimum = this.number(input.dataset.minimum, 1);
        const increment = this.number(input.dataset.increment, 1);
        const maximum = this.maximum(input.dataset.maximum);
        const bounded = Math.min(maximum, Math.max(minimum, requested));
        const steps = Math.ceil((bounded - minimum) / increment);
        return Math.min(maximum, minimum + steps * increment);
      }

      updateRowControls(row) {
        const minus = row.querySelector('[data-quantity-minus]');
        const plus = row.querySelector('[data-quantity-plus]');
        const input = row.querySelector('[data-quantity-input]');
        const addButton = row.querySelector('[data-add-button]');
        const quantity = Number.parseInt(input?.value, 10) || 0;
        const maximum = this.maximum(input?.dataset.maximum);

        if (minus) minus.disabled = quantity === 0;
        if (plus) plus.disabled = quantity >= maximum;
        if (addButton) addButton.disabled = quantity === 0 || addButton.dataset.busy === 'true';
      }

      async addRow(row) {
        const input = row.querySelector('[data-quantity-input]');
        const addButton = row.querySelector('[data-add-button]');
        const status = row.querySelector('[data-row-status]');
        const rowCheckout = row.querySelector('[data-row-checkout]');
        const variantId = row.dataset.variantId;
        const quantity = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);

        if (!variantId || quantity === 0 || addButton.dataset.busy === 'true') return;

        addButton.dataset.busy = 'true';
        addButton.disabled = true;
        addButton.textContent = addButton.dataset.addingLabel;
        status.textContent = '';
        status.classList.remove('is-error');

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity }]
            })
          });
          const payload = await response.json();

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Unable to add this item.');
          }

          input.value = 0;
          addButton.textContent = addButton.dataset.addedLabel;
          status.textContent = '';
          rowCheckout?.classList.remove('hidden');
          await this.refreshCart();

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { source: 'kmc-b2b-order-list', cart: payload }
          }));
        } catch (error) {
          status.textContent = error.message;
          status.classList.add('is-error');
          addButton.textContent = addButton.dataset.addLabel;
        } finally {
          window.setTimeout(() => {
            addButton.dataset.busy = 'false';
            addButton.textContent = addButton.dataset.addLabel;
            this.updateRowControls(row);
          }, 900);
        }
      }

      async refreshCart() {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart.js', {
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) return;

          const cart = await response.json();
          const count = this.querySelector('[data-cart-count]');
          const total = this.querySelector('[data-cart-total]');

          if (count) count.textContent = cart.item_count;
          if (total) total.textContent = this.formatMoney(cart.total_price, cart.currency);
          this.updateMinimumOrderStatus(cart);
          this.floatingCart?.classList.toggle('hidden', cart.item_count === 0);
          this.queueFloatingPositionUpdate();
        } catch (error) {
          // The row add remains successful even if the floating summary cannot refresh.
        }
      }

      updateMinimumOrderStatus(cart) {
        const status = this.querySelector('[data-minimum-order-status]');
        const minimum = Number(this.floatingCart?.dataset.minimumOrderCents) || 0;
        if (!status || minimum <= 0) return;

        const subtotal = Number(cart.items_subtotal_price ?? cart.total_price) || 0;
        const unlocked = subtotal >= minimum;
        status.classList.toggle('is-unlocked', unlocked);

        if (unlocked) {
          status.textContent = status.dataset.unlockedLabel;
          return;
        }

        const minimumText = this.formatMoney(minimum, cart.currency);
        const remainingText = this.formatMoney(Math.max(0, minimum - subtotal), cart.currency);
        status.textContent = `${status.dataset.minimumLabel} ${minimumText} · ${remainingText} ${status.dataset.remainingLabel}`;
      }

      formatMoney(cents, currency) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency',
            currency: currency || this.dataset.moneyCurrency || 'GBP'
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return ((Number(cents) || 0) / 100).toFixed(2);
        }
      }

      filterRows() {
        const category = this.categorySelect?.value || '';
        let visible = 0;

        this.rows.forEach((row) => {
          const show = category === '' || row.dataset.category === category;
          row.hidden = !show;
          if (show) visible += 1;
        });

        this.emptyState?.classList.toggle('hidden', visible > 0);
      }
    }

    customElements.define('kmc-b2b-order-list', KmcB2BOrderList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kmc-b2b-quick-order-2026"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kmc-b2b-quick-list')) {
  class KmcB2BQuickOrder extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.rows = [...this.querySelectorAll('[data-order-row]')];
      this.busy = false;
      this.ready = false;
      this.cartQuantities = new Map();
      this.batchStatus = this.querySelector('[data-batch-status]');
      this.addSelected = this.querySelector('[data-add-selected]');
      this.search = this.querySelector('[data-search]');
      this.category = this.querySelector('[data-category-select]');
      this.sort = this.querySelector('[data-sort-select]');
      this.search?.addEventListener('input', () => this.filter());
      this.category?.addEventListener('change', () => this.filter());
      this.sort?.addEventListener('change', () => this.sortRows());
      this.addSelected?.addEventListener('click', () => this.add(this.rows.filter(row => Number(row.querySelector('input').value) > 0)));
      this.rows.forEach((row,index) => {
        row.dataset.index = index;
        const input = row.querySelector('[data-quantity-input]');
        row.querySelector('[data-quantity-minus]').addEventListener('click', () => {
          const step = this.positive(input.dataset.increment,1);
          input.value = this.normalise(row,Math.max(0,Number(input.value)-step),false);
          this.update();
        });
        row.querySelector('[data-quantity-plus]').addEventListener('click', () => {
          input.value = this.normalise(row,Number(input.value)+this.positive(input.dataset.increment,1));
          this.update();
        });
        input.addEventListener('input', () => this.update());
        input.addEventListener('change', () => { input.value = this.normalise(row,Number(input.value)); this.update(); });
        row.querySelector('[data-add-button]').addEventListener('click', () => this.add([row]));
      });
      this.update();
      this.refreshCart().catch(() => {
        this.batchStatus.textContent = 'Your cart could not be checked. Refresh the page before adding products.';
      });
    }
    positive(value,fallback) { const n=Number(value); return Number.isFinite(n)&&n>0?n:fallback; }
    rules(row) {
      const input=row.querySelector('[data-quantity-input]');
      const existing=this.cartQuantities.get(row.dataset.variantId)||0;
      const step=this.positive(input.dataset.increment,1);
      const min=this.positive(input.dataset.minimum,1);
      const max=this.positive(input.dataset.maximum,Infinity);
      return {existing,step,min,max};
    }
    normalise(row,requested,up=true) {
      if (!Number.isFinite(requested)||requested<=0) return 0;
      const {existing,step,min,max}=this.rules(row);
      const target=existing+requested;
      const rounded=(up?Math.ceil(target/step):Math.floor(target/step))*step;
      const maxValid=Number.isFinite(max)?Math.floor(max/step)*step:Infinity;
      const valid=Math.min(maxValid,Math.max(Math.ceil(min/step)*step,rounded));
      if (!up && target<min) return 0;
      return Math.max(0,valid-existing);
    }
    valid(row) {
      const quantity=Number(row.querySelector('[data-quantity-input]').value);
      const {existing,step,min,max}=this.rules(row);
      return Number.isInteger(quantity)&&quantity>0&&existing+quantity>=min&&existing+quantity<=max&&(existing+quantity)%step===0;
    }
    update() {
      let quantity=0,estimate=0,invalid=false;
      this.rows.forEach(row => {
        const input=row.querySelector('[data-quantity-input]');
        const q=Number(input.value)||0;
        const valid=this.valid(row);
        quantity+=Math.max(0,q);
        estimate+=Math.max(0,q)*Number(row.dataset.price);
        invalid ||= q>0&&!valid;
        const disabled=this.busy||!this.ready;
        input.disabled=disabled;
        row.querySelector('[data-quantity-minus]').disabled=disabled||q<=0;
        const {existing,max}=this.rules(row);
        row.querySelector('[data-quantity-plus]').disabled=disabled||existing+q>=max;
        row.querySelector('[data-add-button]').disabled=disabled||!valid;
        input.setAttribute('aria-invalid',String(q>0&&!valid));
      });
      this.querySelector('[data-selected-total]').textContent=this.money(estimate);
      this.querySelector('[data-selected-count]').textContent=quantity+' packs selected';
      this.addSelected.disabled=this.busy||!this.ready||quantity===0||invalid;
    }
    filter() {
      const query=(this.search.value||'').trim().toLocaleLowerCase();
      const category=this.category.value;
      let count=0;
      this.rows.forEach(row=>{
        const match=(!category||row.dataset.category===category)&&(!query||(row.dataset.name+' '+row.dataset.sku).toLocaleLowerCase().includes(query));
        row.hidden=!match;
        if(match)count++;
      });
      this.querySelector('[data-empty-state]').classList.toggle('hidden',count>0);
    }
    sortRows() {
      const type=this.sort.value;
      const compare=(a,b)=>{
        if(type==='title-ascending'||type==='title-descending')return a.dataset.name.localeCompare(b.dataset.name,undefined,{sensitivity:'base'})*(type==='title-descending'?-1:1);
        if(type==='price-ascending'||type==='price-descending')return (Number(a.dataset.price)-Number(b.dataset.price))*(type==='price-descending'?-1:1);
        return Number(a.dataset.index)-Number(b.dataset.index);
      };
      this.rows.slice().sort(compare).forEach(row=>this.querySelector('[data-order-rows]').appendChild(row));
    }
    async add(rows) {
      if(this.busy||!this.ready||!rows.length||rows.some(row=>!this.valid(row)))return;
      this.busy=true;
      this.batchStatus.textContent='Adding your selection…';
      this.update();
      const items=rows.map(row=>({id:Number(row.dataset.variantId),quantity:Number(row.querySelector('[data-quantity-input]').value)}));
      let confirmed=false;
      try {
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'The selection could not be added.');
        confirmed=true;
        rows.forEach(row=>{row.querySelector('[data-quantity-input]').value=0;row.querySelector('[data-row-status]').textContent='Added to your cart';});
        await this.refreshCart();
        this.batchStatus.textContent='Selection added. Review your cart to confirm prices, quantities and delivery.';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'kmc-b2b-quick-list'}}));
      } catch(error) {
        this.ready=false;
        this.batchStatus.textContent=(confirmed?'Products were added, but the cart summary could not refresh. ':String(error.message)+' ')+'Review your cart before trying again to avoid duplicates.';
      } finally {
        this.busy=false;
        this.update();
      }
    }
    async refreshCart() {
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error('Unable to check your cart.');
      const cart=await response.json();
      this.cartQuantities=new Map();
      cart.items.forEach(item=>this.cartQuantities.set(String(item.variant_id),(this.cartQuantities.get(String(item.variant_id))||0)+item.quantity));
      this.querySelectorAll('[data-cart-count]').forEach(node=>node.textContent=cart.item_count);
      this.querySelectorAll('[data-cart-total]').forEach(node=>node.textContent=this.money(cart.total_price,cart.currency));
      const minimum=this.querySelector('[data-minimum-order]');
      if(minimum){const threshold=Number(minimum.dataset.threshold)||0;const left=Math.max(0,threshold-Number(cart.items_subtotal_price??cart.total_price));minimum.textContent=left>0?'Minimum order '+this.money(threshold,cart.currency)+' · '+this.money(left,cart.currency)+' remaining':'Minimum order '+this.money(threshold,cart.currency)+' reached';}
      this.ready=true;
      this.update();
    }
    money(cents,currency) { return new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:currency||this.dataset.moneyCurrency||'GBP'}).format(cents/100); }
  }
  customElements.define('kmc-b2b-quick-list',KmcB2BQuickOrder);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kmc-custom-branding"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-kmc-product]');
    if (!link) return;
    const section = link.closest('[data-kmc-custom]');
    const select = section.hasAttribute('data-inline-brief') ? document.querySelector('#KmcCustomEnquiry [data-category]') : section.querySelector('select[name="contact[Product interest]"]');
    if (!select || !Array.from(select.options).some(option => option.value === link.dataset.kmcProduct)) return;
    event.preventDefault();
    select.value = link.dataset.kmcProduct;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.focus({ preventScroll: true });
    select.scrollIntoView({ block: 'center', behavior: 'instant' });
  });

  } catch(e) { console.error(e); }
})();
})();
